angular.module('picmonicng').component('practiceQuestions', {
  templateUrl: '/templates/app/components/practice-questions/practice-questions.html',
  bindings: {
    location: '@',
    question: '<',
  },
  controller: [
    'UserService',
    'tlQuestionsResource',
    'XpService',
    '$timeout',
    'PQService',
    'BrowseService',
    'TypeformModal',
    'Picmonics',
    'LocalStorageService',
    'PermissionsService',
    '$filter',
    function (
      UserService,
      tlQuestionsResource,
      XpService,
      $timeout,
      PQService,
      BrowseService,
      TypeformModal,
      Picmonics,
      LocalStorageService,
      PermissionsService,
      $filter
    ) {
      var $ctrl = this;
      $ctrl.loading = false;
      $ctrl.searchTerm = '';
      $ctrl.PQService = PQService;
      $ctrl.canSuggest = PermissionsService.hasAccess('npq_card_suggestions');
      $ctrl.suggestedPicmonics = [];
      $ctrl.isEducator = UserService.user.role === 'Professor';

      if (!PQService.promise) {
        PQService.loadQuestion();
      }

      $ctrl.$onChanges = function (changes) {
        if (!changes.question || $ctrl.location === 'home') {
          return;
        }
        const question = changes.question.currentValue;

        if (question && question.stats && question.stats.answers) {
          angular.forEach($ctrl.question.stats.answers, function (a) {
            $ctrl.selectAnswer($filter('filter')($ctrl.question.answers, { ID: a.answer_id }, true)[0]);
          });

          $ctrl.question.result = question.correct === question.answers.length ? 1 : 0;
          $ctrl.question.submitted = 1;
          $ctrl.explanationOpen = false;

          document.getElementsByClassName('browse-practice-questions-container')[0].scrollIntoView({
            behavior: 'smooth',
          });
        } else {
          $ctrl.question.next_question_id = null;
        }
      };

      $ctrl.getAnswerIcon = function (answer) {
        if ($ctrl.question.submitted) {
          if (answer.Solution) {
            if (answer.selected) {
              return $ctrl.question.QuestionFormatID === 1 ? 'check_box' : 'check_circle';
            }

            return $ctrl.question.QuestionFormatID === 1 ? 'check_box_outline_blank' : 'radio_button_unchecked';
          } else {
            if (answer.selected) {
              return $ctrl.question.QuestionFormatID === 1 ? 'disabled_by_default' : 'cancel';
            }

            return $ctrl.question.QuestionFormatID === 1 ? 'check_box_outline_blank' : 'radio_button_unchecked';
          }
        }

        return answer.selected
          ? $ctrl.question.QuestionFormatID === 1
            ? 'check_box'
            : 'check_circle'
          : $ctrl.question.QuestionFormatID === 1
          ? 'check_box_outline_blank'
          : 'radio_button_unchecked';
      };

      $ctrl.selectAnswer = function (answer) {
        // form already submitted
        if ($ctrl.question.submitted) {
          return;
        }

        // Multi-select toggle
        if ($ctrl.question.QuestionFormatID === 1) {
          answer.selected = answer.selected ? 0 : 1;

          // Single select
        } else {
          // unselect all
          $ctrl.question.answers.forEach(function (answer) {
            answer.selected = 0;
            answer.result = 0;
          });

          // select answer
          answer.selected = 1;
          $ctrl.question.answer_id = answer.ID;
        }

        // count answers
        $ctrl.question.answered = 0;
        $ctrl.question.correct = 0;
        $ctrl.question.answers.forEach(function (answer) {
          answer.result = 0;

          if (answer.selected) {
            $ctrl.question.answered++;
          }

          if (answer.Solution && answer.selected) {
            $ctrl.question.correct++;
            answer.result = 1;
          }

          if (!answer.Solution && !answer.selected) {
            $ctrl.question.correct++;
            answer.result = 1;
          }
        });
      };

      $ctrl.submit = function () {
        if ($ctrl.loading || $ctrl.question.submitted || !$ctrl.question.answered) {
          return;
        }

        if ($ctrl.location === 'home') {
          $ctrl.goToQuestions();
        }

        $ctrl.loading = true;

        // Calculate result
        $ctrl.question.result = $ctrl.question.correct === $ctrl.question.answers.length ? 1 : 0;

        // Manually update stats for the user now but note they will be refreshed after loading the next question anyways
        PQService.stats.completed++;

        if ($ctrl.question.result) {
          PQService.stats.correct++;
        } else {
          PQService.stats.incorrect++;
        }

        var data = Object.assign(
          {},
          {
            resource: 'attempt',
            is_correct: $ctrl.question.result,
            question_id: $ctrl.question.ID,
            root_id: $ctrl.question.RootID,
            unique_name: $ctrl.question.UniqueName,
          },
          $ctrl.question
        );

        tlQuestionsResource.save(data).$promise.finally(function () {
          $ctrl.question.submitted = 1;
          $ctrl.loading = false;

          $ctrl.explanationOpen = !$ctrl.question.result;
        });

        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('click', 'practice-questions-submit-question');
        }
      };

      $ctrl.setQuestionRating = function (rating) {
        $ctrl.question.question_rating = rating;
        $ctrl._grantXp('.question-rating-notification-target');
      };

      $ctrl.setExplanationRating = function (rating) {
        $ctrl.question.explanation_rating = rating;
        $ctrl._grantXp('.explanation-rating-notification-target');
      };

      $ctrl._grantXp = function (notificationTarget) {
        // Prevent extra grant requests
        if ($ctrl.question.xp_granted) {
          return;
        }

        XpService.grant('PracticeQuestionRating', $ctrl.question.UniqueName, angular.element(notificationTarget))
          .$promise.catch(function () {
            // do nothing
          })
          .finally(function () {
            $ctrl.question.xp_granted = 1;
          });
      };

      $ctrl.loadQuestion = function (questionId) {
        if ($ctrl.loading) {
          return;
        }

        $ctrl.loading = true;

        PQService.loadQuestion(questionId).finally(function () {
          $ctrl.loading = false;
        });
      };

      $ctrl.nextQuestion = function () {
        $ctrl.loadQuestion($ctrl.question.next_question_id);
      };

      $ctrl.previousQuestion = function () {
        $ctrl.loadQuestion($ctrl.question.previous_question_id);
      };

      $ctrl.continue = function () {
        // check for loading / feedback not provided
        if ($ctrl.loading) {
          return;
        }

        $ctrl.loading = true;

        var data = Object.assign(
          {},
          {
            resource: 'rate',
            question_id: $ctrl.question.ID,
            suggested_picmonics: $ctrl.suggestedPicmonics,
          },
          $ctrl.question
        );

        tlQuestionsResource.update(data).$promise.finally(function () {
          PQService.loadQuestion().finally(function () {
            $ctrl.loading = false;
          });
        });

        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('click', 'practice-questions-next-question');
        }

        $ctrl.clearSuggestedPicmonics();
      };

      $ctrl.goToQuestions = function () {
        UserService.see('nav_practice_questions_clicked');

        if (
          BrowseService.secondaryState &&
          BrowseService.secondaryState.indexOf('app.practice-questions') === 0 &&
          BrowseService.secondaryVisible &&
          BrowseService.browseOpen
        ) {
          BrowseService.toggleOpen();
        } else {
          BrowseService.go('app.practice-questions');
        }
      };

      $ctrl.closeBrowse = function (card) {
        if (typeof atlasEvent !== 'undefined') {
          atlasEvent(
            'click',
            'practice-questions-picmonic-clicked ' +
              card.id +
              ' ' +
              $ctrl.question.ID +
              ' ' +
              $ctrl.question.RootID +
              ' ' +
              $ctrl.question.UniqueName
          );
        }

        BrowseService.setOpen(false, false);
      };

      $ctrl.search = function () {
        $ctrl.searching = true;

        $ctrl.searchResults = Picmonics.search({
          source: 'practice-questions',
          query: $ctrl.searchTerm,
          page: 1,
          searchPicmonics: true,
          searchPathways: false,
          searchBreadcrumbs: false,
          sort_by: 'relevance',
          include_ugc: false,
          market_id: 101,
          quick: 1,
        });

        $ctrl.searchResults.$promise.finally(function () {
          $ctrl.searching = false;
          $ctrl.searchOpen = true;
        });
      };

      $ctrl.suggestPicmonic = function (picmonic) {
        $ctrl.clearSuggestedPicmonicsSearchTerm();

        existing = false;

        angular.forEach($ctrl.suggestedPicmonics, function (suggestion) {
          if (suggestion.id === picmonic.id) {
            existing = true;
          }
        });

        if (existing) {
          return;
        }

        $ctrl.suggestedPicmonics.push(picmonic);

        $timeout(function () {
          XpService.grant(
            'PracticeQuestionPicmonicSuggestion',
            $ctrl.question.UniqueName,
            angular.element('.suggested-picmonic')
          )
            .$promise.catch(function () {
              // do nothing
            })
            .finally(function () {
              $ctrl.question.xp_granted = 1;
            });
        });
      };

      $ctrl.clearSuggestedPicmonic = function (index) {
        $ctrl.suggestedPicmonics = $ctrl.suggestedPicmonics.splice(index, 1);
        $ctrl.clearSuggestedPicmonicsSearchTerm();
      };

      $ctrl.clearSuggestedPicmonics = function () {
        $ctrl.suggestedPicmonics = [];
        $ctrl.clearSuggestedPicmonicsSearchTerm();
      };

      $ctrl.clearSuggestedPicmonicsSearchTerm = function () {
        $ctrl.searchTerm = '';
        $ctrl.searchOpen = false;
        $ctrl.searchResults = [];
      };

      $ctrl.toggleExplanation = function () {
        $ctrl.explanationOpen = !$ctrl.explanationOpen;
      };

      $ctrl.getAnswerResultText = function (answer) {
        if (answer.Solution) {
          return answer.selected ? 'Correct!' : 'Missed';
        } else {
          return answer.selected ? 'Incorrect' : '';
        }
      };

      $ctrl.getPricingLink = function () {
        switch (UserService.user.lead) {
          case 101:
          case 202:
            return 503;
          case 100:
            return 504;
          case 203:
            return 505;
          case 115:
            return 507;
          case 116:
            return 508;
          case 109:
            return 509;
          case 122:
            return 510;
          case 117:
            return 511;
          default:
            return;
        }
      };

      $ctrl.tlMarketInfo = {
        503: {
          title: 'Test Your Best with TrueLearn’s NCLEX-RN® Question Bank',
          marketTitle: 'NCLEX<sup>®<sup>',
          marketId: 503,
          valueProps: [
            {
              icon: 'quiz',
              text: '900+ NCLEX-RN® practice questions linked to relevant Picmonics to reinforce topics after quizzing',
            },
            {
              icon: 'verified',
              text: 'Mapped to current NCLEX-RN Test Plan Client Needs categories',
            },
            {
              icon: 'video_library',
              text: 'View Picmonics from the Recent Incorrect Topics on your dashboard to tackle weak areas head-on',
            },
            {
              icon: 'fact_check',
              text: 'Customize practice tests by subjects, systems, client needs or specific keyword',
            },
            {
              icon: 'library_books',
              text: 'Detailed explanations, evidence-based rationales and linked references with every question for deeper learning',
            },
            {
              icon: 'poll',
              text: 'Performance analytics and real-time national benchmarking',
            },
          ],
          pricingTileBullets: ['Mapped to current NCLEX-RN Test Plan'],
        },
        504: {
          title: 'Test Your Best with TrueLearn’s USMLE Step 1 Question Bank',
          marketTitle: 'USMLE<sup>®</sup> Step 1',
          marketId: 504,
          valueProps: [
            {
              icon: 'quiz',
              text: '2,400+ USMLE Step 1 practice questions linked to relevant Picmonics to reinforce topics after quizzing',
            },
            {
              icon: 'verified',
              text: 'Explanations include corresponding First Aid for the USMLE Step 1 (2022, 2021 and 2020) page numbers for deeper learning',
            },
            {
              icon: 'video_library',
              text: 'View Picmonics from the Recent Incorrect Topics list on your dashboard to tackle your weakest areas head-on',
            },
            {
              icon: 'library_books',
              text: 'Detailed explanations and evidence-based rationales with every question',
            },
            {
              icon: 'fact_check',
              text: 'Customize practice tests by systems, disciplines, competencies, processes or specific keyword',
            },
            {
              icon: 'poll',
              text: 'Performance analytics and real-time national benchmarking',
            },
          ],
          pricingTileBullets: [
            'Mapped to current USMLE Step 1 content outline',
            'Mimics the exam interface you’ll see on test day',
          ],
        },
        505: {
          title: 'Test Your Best with TrueLearn’s Family Nurse Practitioner Question Bank',
          marketTitle: 'Nurse Practitioner',
          marketId: 505,
          valueProps: [
            {
              icon: 'quiz',
              text: '1,800+ practice questions to prepare for the AANP and ANCC exams',
            },
            {
              icon: 'video_library',
              text: 'Questions linked to relevant Picmonics to reinforce topics after quizzing',
            },
            {
              icon: 'dashboard',
              text: 'View Picmonics from the Recent Incorrect Topics on your dashboard to tackle your weakest areas head-on',
            },

            {
              icon: 'library_books',
              text: 'Detailed explanations, evidence-based rationales and linked references with every question for deeper learning',
            },
            {
              icon: 'fact_check',
              text: 'Customize practice tests by systems, clinical areas or specific keyword',
            },
            {
              icon: 'poll',
              text: 'Performance analytics and real-time national benchmarking',
            },
          ],
          tileTitle: 'FNP SmartBank',
          pricingTileBullets: ['Prepare for the AANP and ANCC exams'],
        },
        506: {
          title: 'Test Your Best with TrueLearn’s COMBANK Level 1 Question Bank',
          marketTitle: 'COMBANK<sup>®</sup> Level 1',
          marketId: 506,
          valueProps: [
            {
              icon: 'quiz',
              text: '2,000+ COMLEX Level 1 practice questions linked to relevant Picmonics to reinforce topics after quizzing',
            },
            {
              icon: 'verified',
              text: 'Explanations include corresponding First Aid for the USMLE Step 1 (2022, 2021 and 2020) page numbers for deeper learning',
            },
            {
              icon: 'video_library',
              text: 'View Picmonics from the Recent Incorrect Topics list on your dashboard to tackle your weakest areas head-on',
            },
            {
              icon: 'library_books',
              text: 'Detailed explanations and evidence-based rationales with every question',
            },
            {
              icon: 'fact_check',
              text: 'Customize practice tests by systems, disciplines, competency domains, clinical presentations or specific keyword',
            },
            {
              icon: 'poll',
              text: 'Performance analytics and real-time national benchmarking',
            },
          ],
          pricingTileBullets: ['Mapped to current NBOME Blueprint', 'Mimics the exam interface you’ll see on test day'],
        },
        507: {
          title: 'Test Your Best with TrueLearn’s NPTE Question Bank',
          marketTitle: 'NPTE<sup>®</sup>',
          marketId: 507,
          valueProps: [
            {
              icon: 'quiz',
              text: '1,000+ NPTE practice questions linked to relevant Picmonics to reinforce topics after quizzing',
            },
            {
              icon: 'verified',
              text: 'Topics mapped to current NPTE-PT Content Outline',
            },
            {
              icon: 'video_library',
              text: 'View Picmonics from the Recent Incorrect Topics on your dashboard to tackle weak areas head-on',
            },
            {
              icon: 'fact_check',
              text: 'Customize practice tests by body systems, disciplines or specific keyword',
            },
            {
              icon: 'library_books',
              text: 'Detailed explanations, evidence-based rationales and linked references with every question for deeper learning',
            },
            {
              icon: 'poll',
              text: 'Performance analytics and real-time national benchmarking',
            },
          ],
          pricingTileBullets: ['Mapped to current NPTE-PT Content Outline'],
        },
        508: {
          title: 'Test Your Best with TrueLearn’s OT Question Bank',
          marketTitle: 'NBCOT<sup>®</sup>',
          marketId: 508,
          valueProps: [
            {
              icon: 'quiz',
              text: '1,200+ exam-style practice questions linked to relevant Picmonics to reinforce topics after quizzing',
            },
            {
              icon: 'verified',
              text: 'Topics mapped to current NBCOT® Exam Content Outline',
            },
            {
              icon: 'video_library',
              text: 'View Picmonics from the Recent Incorrect Topics on your dashboard to tackle weak areas head-on',
            },
            {
              icon: 'fact_check',
              text: 'Customize practice tests by topics, domains, question types (CST or MCQ) or specific keyword',
            },
            {
              icon: 'library_books',
              text: 'Detailed explanations, evidence-based rationales and linked references with every question for deeper learning',
            },
            {
              icon: 'poll',
              text: 'Performance analytics and real-time national benchmarking',
            },
          ],
          pricingTileBullets: ['Mapped to current NBCOT® Exam Content Outline'],
        },
        509: {
          title: 'Test Your Best with TrueLearn’s NAPLEX Question Bank',
          marketTitle: 'NAPLEX<sup>®</sup>',
          marketId: 509,
          valueProps: [
            {
              icon: 'quiz',
              text: '1,400+ NAPLEX practice questions linked to relevant Picmonics to reinforce topics after quizzing',
            },
            {
              icon: 'verified',
              text: 'Topics mapped to current NAPLEX Blueprint',
            },
            {
              icon: 'video_library',
              text: 'View Picmonics from the Recent Incorrect Topics on your dashboard to tackle weak areas head-on',
            },
            {
              icon: 'fact_check',
              text: 'Customize practice tests by therapeutic topics, disciplines, top 200 drugs or specific keyword',
            },
            {
              icon: 'library_books',
              text: 'Detailed explanations, evidence-based rationales and linked references with every question for deeper learning',
            },
            {
              icon: 'poll',
              text: 'Performance analytics and real-time national benchmarking',
            },
          ],
          pricingTileBullets: ['Mapped to current NAPLEX Blueprint'],
        },
        510: {
          title: 'Test Your Best with TrueLearn’s Pharmacy Technician Question Bank',
          marketTitle: 'Pharmacy Technician',
          marketId: 510,
          valueProps: [
            {
              icon: 'quiz',
              text: '1,000+ exam-style practice questions linked to relevant Picmonics to reinforce topics after quizzing',
            },
            {
              icon: 'verified',
              text: 'Topics mapped to PTCE® and ExCPT® exams',
            },
            {
              icon: 'video_library',
              text: 'View Picmonics from the Recent Incorrect Topics on your dashboard to tackle weak areas head-on',
            },
            {
              icon: 'fact_check',
              text: 'Customize practice tests by blueprint topics, medications or specific keyword',
            },
            {
              icon: 'library_books',
              text: 'Detailed explanations, evidence-based rationales and linked references with every question for deeper learning',
            },
            {
              icon: 'poll',
              text: 'Performance analytics and real-time national benchmarking',
            },
          ],
          pricingTileBullets: ['Prepare for the PTCE® and ExCPT® exams'],
        },
        511: {
          title: 'Test Your Best with TrueLearn’s MA Certification Question Bank',
          marketTitle: 'MA Certification',
          marketId: 511,
          valueProps: [
            {
              icon: 'quiz',
              text: '900+ exam-style practice questions linked to relevant Picmonics to reinforce topics after quizzing',
            },
            {
              icon: 'verified',
              text: 'Topics mapped to CMA, RMA, NCMA, & CCMA exams',
            },
            {
              icon: 'video_library',
              text: 'View Picmonics from the Recent Incorrect Topics on your dashboard to tackle weak areas head-on',
            },
            {
              icon: 'fact_check',
              text: 'Customize practice tests by exam topics, competencies, MAERB requirements or specific keyword',
            },
            {
              icon: 'library_books',
              text: 'Detailed explanations, evidence-based rationales and linked references with every question for deeper learning',
            },
            {
              icon: 'poll',
              text: 'Performance analytics and real-time national benchmarking',
            },
          ],
          pricingTileBullets: ['Prepare for the CMA, RMA, NCMA, & CCMA exams'],
        },
      };

      $ctrl.tlCurrentMarketInfo = $ctrl.tlMarketInfo[$ctrl.getPricingLink()];
    },
  ],
});
